var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.864,
    height: 25,
    viewBox: "0 0 21.864 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83866",
    "data-name": "Path 83866",
    d: "M77.871,346.08a.61.61,0,0,0,.121.17.649.649,0,0,1,.121.455v13.636a3.469,3.469,0,0,1-3.644,3.409H59.894a3.469,3.469,0,0,1-3.644-3.409V342.159a3.469,3.469,0,0,1,3.644-3.409h9.717a.77.77,0,0,1,.486.114c.121,0,.243.114.364.227l7.288,6.818A.593.593,0,0,1,77.871,346.08Zm-3.887-.512-3.158-2.955v2.955Zm.486,15.909H59.894a1.112,1.112,0,0,1-1.215-1.136V342.159a1.112,1.112,0,0,1,1.215-1.136h8.5V346.7a1.112,1.112,0,0,0,1.215,1.136h6.073v12.5A1.112,1.112,0,0,1,74.47,361.477Zm-2.429-7.955a1.139,1.139,0,1,0,0-2.273H62.323a1.139,1.139,0,1,0,0,2.273Zm1.215,3.409a1.112,1.112,0,0,1-1.215,1.136H62.323a1.139,1.139,0,1,1,0-2.273h9.717A1.112,1.112,0,0,1,73.256,356.932ZM62.323,346.7a1.139,1.139,0,1,0,0,2.273h2.429a1.139,1.139,0,1,0,0-2.273Z",
    transform: "translate(-56.25 -338.75)",
    fill: "#0f4e9b",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusImg);
export default __webpack_public_path__ + "static/media/status_img.4eb30225775c482846e0f3aa0ae59d7a.svg";
export { ForwardRef as ReactComponent };